import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-course-branch',
  templateUrl: './course-branch.component.html',
  styleUrls: ['./course-branch.component.scss']
})
export class CourseBranchComponent implements OnInit {
  CourseBranch: FormGroup;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  deleteButton=false;
  list;
  dialogRef: any;
  APIService: any;
  districtList: any;
  isreadonly = false;
  isreadonlydel = false;
  submitpayload: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,private httpClient: HttpClient,   public router: Router,
    private route: ActivatedRoute, private spinner:NgxSpinnerService,) { this.APIService = environment.serviceUrl;}

  ngOnInit(): void {
    
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton= false;
   
    this.list = true;
    this.CourseBranch = this.fb.group({
     
      // CoPattern: new FormControl ('', [ Validators.pattern("^[a-zA-Z0-9]*$")]),
      // CoRule: new FormControl ('', [ Validators.pattern("^[a-zA-Z0-9]*$")]),
      // CoPassPC: new FormControl ('', [ Validators.pattern("^([0-9]{0,2})(.[0-9]{1,2}){0,1}$|^100$")]),
      // CoProgCGPA: new FormControl ('', [ Validators.pattern("^([0-9]{0,2})(.[0-9]{1,2}){0,1}$|^100$")]),
      // CoCBCS: new FormControl ('', [ Validators.pattern("^[a-zA-Z0-9]*$")]),
      
    });
    // this.CourseBranch = this.fb.group({
    //   SearchString: new FormControl ('')
    // })
  }

  getDistrictData() {
    const payload = {};
    this.umsService.getDistrict(payload).subscribe(res => {
  this.districtList = res.data;
}, (ERROR: HttpErrorResponse) => {
  this.districtList = [];
  let  data = {}
  data['message'] = ERROR.error.message
  data['title'] = 'Information'
  data['icon'] = 'fas fa-box-open'
  this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
});
}

prepopulation(id) {
  // this.spinner.show();
const payload = {};
// tslint:disable-next-line:no-string-literal
payload['DsCode'] = id;
// tslint:disable-next-line:no-string-literal
payload['DsName'] = id;
this.umsService.getDistrict(payload).subscribe((res) => {
  // this.spinner.hide();
  const data = res.data[0];
  if (res.status) {
    this.editButton = true;
    this.isreadonly = true;
    this.submitButton = false;
    this.deleteButton = false;
    this.CourseBranch = this.fb.group({
      DsCode: new FormControl(data.DsCode, [Validators.required, Validators.pattern('^[0-9]*$')]),
      DsName: new FormControl(data.DsName, [Validators.required, Validators.pattern('^[a-zA-Z-&\\s]*$')]),
    });
  } else {
    let  data = {}
    data['message'] = res.message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-box-open'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }
});
}



deletedata(id){
const options = {
headers: new HttpHeaders({
  'Content-Type': 'application/json',
}),  body: {
  DsName: id.DsName,
  DsCode: id.DsCode,

},
};
this.httpClient.delete(this.APIService + '/masters/district', options)
.subscribe((s) => {
  // this.spinner.hide();
  let cc = [];
  cc.push(s);
  let  data = {}
  data['message'] = cc[0].message
  data['title'] = 'Information'
  data['icon'] = 'fas fa-check'
  this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  this.dialogRef.afterClosed().subscribe(result => {
    this.ngOnInit();
  });
},(ERROR: HttpErrorResponse) => {

  let  data = {}
  data['message'] = ERROR.error.message
  data['title'] = 'Alert'
  data['icon'] = 'fas fa-close'
  this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  this.ngOnInit();
  // this.umsService.openSnackbar(ERROR.error.message);

});

}


deletee(e, k){
if (e === 'true'){
  this.list = false;
  this.getDistrictData(); 
  const payload = {};
  // tslint:disable-next-line:no-string-literal
  payload['DsCode'] = k;
  // tslint:disable-next-line:no-string-literal
  payload['DsName'] = k;
  this.umsService.getDistrict(payload).subscribe((res) => {
    const data = res.data[0];
    if (res.status) {
      this.editButton = false;
      this.submitButton = false;
      this.isreadonlydel = true;
      this.deleteButton = true;
      this.CourseBranch = this.fb.group({
        DsCode: new FormControl(data.DsCode, [Validators.required, Validators.pattern('^[0-9]*$')]),
        DsName: new FormControl(data.DsName, [Validators.required, Validators.pattern('^[a-zA-Z-&\\s]*$')]),
      });
     // this.DsCodefordelete =  this.CourseBranch.value;
    } else {
      let  data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
  });
} else {
  this.list = true;
}
}
openConformationModalBox(){
let  data = {}
data['message'] = 'Are You Sure You Want To Delete This Record ?'
data['title'] = 'Alert'
data['icon'] = 'fa fa-question'
this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
this.dialogRef.afterClosed().subscribe(result => {
  if(result == 'yes'){
    // this.deletedata(this.DsCodefordelete);
  }else{
    // this.ngOnInit();
  } 
});
}

keypress(){
// this.umsService.searchDistrict(this.DistrictSearchForm.value).subscribe(res => {
//   this.districtList = res.data;
//   },(ERROR: HttpErrorResponse) => {
//     this.districtList = [];
//  });
}

submit() {
if (this.CourseBranch.invalid) {
  this.CourseBranch.get('DsCode').markAsTouched();
  this.CourseBranch.get('DsName').markAsTouched();
  return;
} else {
  this.createCourseBranch();
}

}



createCourseBranch() {
  this.spinner.show();
this.submitpayload = this.CourseBranch.value;
this.umsService.addDistrict(this.submitpayload).subscribe(res => {
  this.spinner.hide();
  if (res.status) {

    let  data = {}
    data['message'] = res.message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-check'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
     // this.dialogRef.afterClosed().subscribe(result => {
    //   this.ngOnInit();
    // });
  } else {
    
    let  data = {}
    data['message'] = res.message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-close'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
     // this.dialogRef.afterClosed().subscribe(result => {
    //   this.ngOnInit();
    // });
  }
},(ERROR: HttpErrorResponse) => {
  this.districtList = [];
  let  data = {}
  data['message'] = ERROR.error.message
  data['title'] = 'Information'
  data['icon'] = 'fas fa-check'
  this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
});
}

update() {
if (this.CourseBranch.invalid) {
  this.CourseBranch.get('DsCode').markAsTouched();
  this.CourseBranch.get('DsName').markAsTouched();
  return;
} else {
  this.updateCourseBranch();
}
}

updateCourseBranch() {
  this.spinner.show();
this.submitpayload = this.CourseBranch.value;
this.umsService.updateDistrict(this.submitpayload).subscribe(res => {
  this.spinner.hide();
  if (res.status){
    let  data = {}
    data['message'] = res.message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-check'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
     // this.dialogRef.afterClosed().subscribe(result => {
    //   this.ngOnInit();
    // });
  } else {
    let  data = {}
    data['message'] = res.message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-close'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
     // this.dialogRef.afterClosed().subscribe(result => {
    //   this.ngOnInit();
    // });
  }
});
}

addnewrecord(e){
if (e === 'true'){
  this.list = false;
  this.submitButton = true;
  this.isreadonly = false;
  this.editButton = false;
  this.isreadonlydel = false;
  this.deleteButton = false;
  this.CourseBranch = this.fb.group({
    DsCode: new FormControl ('', [Validators.required, Validators.pattern('^[0-9]*$')]),
    DsName: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-Z-&\\s]*$')]),
  });
} else {
  this.list = true;
  this.getDistrictData();
}
}

editdata(e, k){
if (e === 'true'){
  this.list = false;
  this.isreadonly = false;
  this.getDistrictData();
  // this.CourseBranch = k;
  this.prepopulation(k);
} else {
  this.list = true;
}
}

redirect(to): void {
this.router.navigate([to]);
}


}
